<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import {required} from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import {FulfillingBouncingCircleSpinner} from "epic-spinners";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import MaskedInput from 'vue-text-mask'
Vue.component("v-select", vSelect);

// register the plugin on vue
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";

Vue.use(Toasted);
/**
 * Departamento component
 */
export default {
  page: {
    title: "Usuarios",
    meta: [{name: "description", content: appConfig.description}],
  },

  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      // imagenes
      file: null,
      localImagen: null,

      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {
          "x-token": this.$store.state.authfack.user.token,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
      },
      dataSelect: [],
      dataSelect1: [],
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "users/get",
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      form: {
        usuario: "",
        password: "",
        empleado: {},
        role: "",
        state: true,
        id: 0,
        img: "",
      },
      tiendasData: [],
      updating: false,
      estadotabla: true,
      title: "Usuarios",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Departamentos",
          active: true,
        },
      ],
      fields: [
        {
          name: "usuario",
          sortField: "usuario",
          title: "Usuario",
          width: "20%",
        },
        {
          name: "empleado.persona.nombre_persona",
          sortField: "empleado.persona.nombre_persona",
          title: "Nombre",
          width: "20%",
        },
        {
          name: "empleado.persona.apellido_persona",
          sortField: "empleado.persona.apellido_persona",
          title: "Apellido",
          width: "20%",
        },
        {
          name: "role.rol",
          sortField: "role.rol",
          title: "Rol",
          width: "20%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      searchType: [
        {nombre: "Nombre", value: "nombre_persona"},
        // { nombre: "Apellido", value: "apellido_persona" },
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_persona",
      sortDesc: false,
      searchLabel: {nombre: "Nombre", value: "nombre"},
      filterLabel: {nombre: "Nombre", value: "nombre"},
      showModalL: false, //Loading
      showModalE: false, //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    form: {
      usuario: {
        required,
      },
      password: {
        required,
      },
      role: {
        required,
      },
      empleado: {
        required,
      },
    },
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: {"x-token": usuario.token},
      })
          .then((res) => {
            if (res.data.success) {
              // this.$router.push("/");
            }
          })
          .catch(() => {
            this.logout();
            location.reload();
          });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,

    // Imagenes
    onSelectedImagen(event) {
      const file = event.target.files[0];
      if (!file) {
        this.localImagen = null;
        return;
      }
      this.file = file;
      const fr = new FileReader();
      fr.onload = () => (this.localImagen = fr.result);
      fr.readAsDataURL(file);
    },
    onSelectImagen() {
      this.$refs.imageSelector.click();
    },
    //Tiendas para llegar el v-select
    // SELECT Empleado
    async selectEmpleado() {
      let me = this;
      this.dataSelect = [];
      const response = await axios.get(this.apiUrl + "users/empleados", {
        headers: {"x-token": this.userT.token},
      });
      me.dataSelect = response.data.data;
      // console.log( me.dataSelect )
    },
    // SELECT Role
    async selectRol() {
      let me = this;
      this.dataSelect1 = [];
      const response = await axios.get(this.apiUrl + "users/rol", {
        headers: {"x-token": this.userT.token},
      });
      me.dataSelect1 = response.data.data;
    },
    clean() {
      this.form = {
        usuario: "",
        password: "",
        empleado: {},
        role: "",
        state: true,
        id: 0,
        img: "",
      }
    },
    //Validaciones antes de guardar
    validaciones(action) {
      this.$v.$touch();
      const {usuario, password, empleado, role} = this.form;

      if (usuario != "" && password != "" && empleado != "" && role != "") {
        if (action == "save") {
          this.save();
        }
        if (action == "update") {
          this.update();
        }
      }
    },
    //Desactivar registro
    desactivate() {
      const {id, usuario} = this.form;
      axios
          .put(
              process.env.VUE_APP_URL + "users/desactivate",
              {
                id: id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.showModalD = false;
            Vue.toasted.error(usuario + " Desactivado", this.options);
            this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            Vue.toasted.error("Error para desactivar", this.options);
          });
    },
    //Activar registro
    activate() {
      const {id, usuario} = this.form;
      axios
          .put(
              process.env.VUE_APP_URL + "users/activate",
              {
                id: id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            this.showModalA = false;
            Vue.toasted.info(usuario + " Activado", this.options);
            this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            Vue.toasted.error("Error para activar", this.options);
          });
    },
    //Guardar registro
    save() {
      const {usuario, password, empleado, role} = this.form;
      const me = this;

      let data = new FormData();
      data.append("usuario", usuario);
      data.append("password", password);
      data.append("empleado", empleado.id);
      data.append("rol", role.id);
      data.append("archivo", this.file);

      axios
          .post(process.env.VUE_APP_URL + "users/store", data, {
            headers: {"x-token": this.userT.token},
          })
          .then(() => {
            Vue.toasted.success(usuario + " Guardado", this.options);
            me.clean();
            me.$refs.vuetable.refresh();
            this.showModalN = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          })
          .finally(() => {
            this.showModalL = false;
          });
    },
    //ACtualizar registro
    update() {
      const {usuario, password, empleado, role, id} = this.form;
      const me = this;
      axios
          .put(
              process.env.VUE_APP_URL + "users/update",
              {
                id: id,
                usuario,
                password,
                empleado: empleado.id,
                rol: role.id,
              },
              {
                headers: {"x-token": this.userT.token},
              }
          )
          .then(() => {
            Vue.toasted.success(usuario + " Actualizado", this.options);
            me.$refs.vuetable.refresh();
            this.showModalE = false;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar", this.options);
          })
          .finally(() => {
            this.showModalL = false;
          });
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
          ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
          : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.form.id = 0;
      this.form.nombre = "";
      this.form.apellido = "";
      this.form.cui = "";
      this.form.tiendaid = "";
      this.form.sexo = "";
      this.form.email = "";
      this.form.telefono = "";
      this.form.direccion = "";
      this.form.state = true;
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;

          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "edit-item") {
        this.selectEmpleado();
        this.selectRol();
        console.log(data);
        //   this.form.nombre = data.persona.nombre_persona;
        this.form.img = data.img;
        this.form.state = data.estado_user;
        this.form.empleado.nombre =
            data.empleado.persona.nombre_persona +
            " " +
            data.empleado.persona.apellido_persona;
        this.form.empleado.id = data.empleado.id;
        this.form.role = data.role;
        this.form.usuario = data.usuario;
        this.form.state = data.estado_user;
        this.form.id = data.id;
      }
      if (action == "new-item") {
        this.selectEmpleado();
        this.selectRol();
        this.form.id = 0;
        this.form.role = "";
        this.form.password = "";
        this.form.usuario = "";
        this.form.empleado.nombre = "";
        this.form.empleado.id = 0;
        this.form.state = "";
      }
      if (action == "desactivate-item") {
        this.form.usuario = data.usuario;
        this.form.id = data.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.form.usuario = data.usuario;
        this.form.id = data.id;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="itemst"/>

    <div class="row">
      <div class="col-12">
        <b-modal
            centered
            v-model="showModalL"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
            no-close-on-backdrop
            content-class="my-class"
            header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                      :animation-duration="2000"
                      :size="90"
                      color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
            centered
            v-model="showModalA"
            title="Activar Departamento"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Activar el Empleado {{ this.form.nombre }}?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
              >Cancelar
              </b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
            centered
            v-model="showModalD"
            title="Desactivar"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Desactivar el Empleado {{ this.form.nombre }}?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
              >Cancelar
              </b-button
              >
              <b-button variant="danger" @click="desactivate"
              >Desactivar
              </b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal para Editar-->
        <b-modal
            centered
            ref="modalUpdate"
            id="modalUpdate"
            title="Editar usuario"
            no-close-on-backdrop
            v-model="showModalE"
            @hidden="closeModal('update')"
            @show="openModal('uptade')"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Usuario</label>
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Ingrese usuario"
                      :class="{
                      'is-invalid': $v.form.usuario.$error,
                    }"
                      @input="$v.form.usuario.$touch()"
                      v-model.trim="$v.form.usuario.$model"
                      :state="!$v.form.usuario.$error"
                  />
                  <div
                      v-if="$v.form.usuario.$error && !$v.form.usuario.required"
                      class="invalid-feedback"
                  >
                    El usuario es obligatorio.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Password</label>
                  <input
                      type="password"
                      class="form-control"
                      placeholder="Ingrese contraseña"
                      :class="{
                      'is-invalid': $v.form.password.$error,
                    }"
                      @input="$v.form.password.$touch()"
                      v-model.trim="$v.form.password.$model"
                      :state="!$v.form.password.$error"
                  />
                  <div
                      v-if="$v.form.password.$error && !$v.form.password.required"
                      class="invalid-feedback"
                  >
                    La contraseña es obligatoria.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label>Empleado</label>
                  <v-select
                      v-model.trim="$v.form.empleado.$model"
                      :state="!$v.form.empleado.$error"
                      :options="dataSelect"
                      label="nombre"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.form.empleado.$error && !$v.form.empleado.required,
                    }"
                  >
                    Debe seleccionar un empleado
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label>Roles</label>
                  <v-select
                      v-model.trim="$v.form.role.$model"
                      :state="!$v.form.role.$error"
                      :options="dataSelect1"
                      label="rol"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block': $v.form.role.$error && !$v.form.role.required,
                    }"
                  >
                    Debe seleccionar un empleado
                  </div>
                </div>
              </div>
              <!--              <div class="col-12">-->
              <!--                <img-->
              <!--                  :src="apiUrl + 'users/get/imagen/' + form.img"-->
              <!--                  class="list-thumbnail responsive border-0 rounded-corners"-->
              <!--                  width="50%"-->
              <!--                />-->
              <!--              </div>-->
            </div>
            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="closeModal('update')"
              >Cerrar
              </b-button
              >
              <b-button
                  @click="validaciones('update')"
                  variant="success"
                  class="ms-1"
              >Guardar
              </b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal de Nuevo Registro-->
        <b-modal
            centered
            @show="openModal('save')"
            @hidden="openModal('save')"
            v-model="showModalN"
            id="modalSave"
            ref="modalSave"
            title="Nuevo usuario"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Usuario</label>
                  <input
                      type="text"
                      class="form-control"
                      placeholder="Ingrese usuario"
                      :class="{
                      'is-invalid': $v.form.usuario.$error,
                    }"
                      @input="$v.form.usuario.$touch()"
                      v-model.trim="$v.form.usuario.$model"
                      :state="!$v.form.usuario.$error"
                  />
                  <div
                      v-if="$v.form.usuario.$error && !$v.form.usuario.required"
                      class="invalid-feedback"
                  >
                    El usuario es obligatorio.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Password</label>
                  <input
                      type="password"
                      class="form-control"
                      placeholder="Ingrese contraseña"
                      :class="{
                      'is-invalid': $v.form.password.$error,
                    }"
                      @input="$v.form.password.$touch()"
                      v-model.trim="$v.form.password.$model"
                      :state="!$v.form.password.$error"
                  />
                  <div
                      v-if="$v.form.password.$error && !$v.form.password.required"
                      class="invalid-feedback"
                  >
                    La contraseña es obligatoria.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label>Empleado</label>
                  <v-select
                      v-model.trim="$v.form.empleado.$model"
                      :state="!$v.form.empleado.$error"
                      :options="dataSelect"
                      label="nombre"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block':
                        $v.form.empleado.$error && !$v.form.empleado.required,
                    }"
                  >
                    Debe seleccionar un empleado
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label>Roles</label>
                  <v-select
                      v-model.trim="$v.form.role.$model"
                      :state="!$v.form.role.$error"
                      :options="dataSelect1"
                      label="rol"
                  ></v-select>
                  <div
                      :class="{
                      'invalid-feedback': true,
                      'd-block': $v.form.role.$error && !$v.form.role.required,
                    }"
                  >
                    Debe seleccionar un empleado
                  </div>
                </div>
              </div>
              <!--              <div class="col d-grid gap-2">-->
              <!--                <label>Imagen de usuario</label>-->
              <!--                <input-->
              <!--                  type="file"-->
              <!--                  v-show="false"-->
              <!--                  accept="image/png, image/jpeg"-->
              <!--                  @change="onSelectedImagen"-->
              <!--                  ref="imageSelector"-->
              <!--                />-->

              <!--                <b-button-->
              <!--                  block-->
              <!--                  class="mb-2"-->
              <!--                  size="md"-->
              <!--                  @click="onSelectImagen"-->
              <!--                  variant="primary"-->
              <!--                >-->
              <!--                  <i :class="'bx bx-image-add'" />&nbsp;&nbsp;Agregar imagen de-->
              <!--                  usuario-->
              <!--                </b-button>-->
              <!--                <div align="center">-->
              <!--                  <img-->
              <!--                    class="rounded-corners"-->
              <!--                    v-if="localImagen"-->
              <!--                    :src="localImagen"-->
              <!--                    width="50%"-->
              <!--                  />-->
              <!--                </div>-->
              <!--              </div>-->
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
              >Cerrar
              </b-button
              >
              <b-button
                  @click="validaciones('save')"
                  variant="success"
                  class="ms-1"
              >Guardar
              </b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Empleados</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                    id="tickets-table_length"
                    class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="changeTypeSearch(search)"
                      >{{ search.nombre }}
                      </b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-3 text-md-start">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                        v-model="search"
                        type="search"
                        @input="onFiltered()"
                        placeholder="Buscar..."
                        class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-5">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <button
                        v-b-modal.modalSave
                        type="button"
                        class="btn btn-success btn-rounded mb-2 me-2"
                        @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nuevo Usuario
                    </button>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                  ref="vuetable"
                  class="table-divided table-responsive order-with-arrow"
                  :css="css.table"
                  :api-url="apiBase"
                  :http-options="httpOptions"
                  :reactive-api-url="true"
                  :fields="fields"
                  :per-page="perPage"
                  :query-params="makeQueryParams"
                  pagination-path
                  @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                        v-if="props.rowData.estado_user"
                        tabindex="0"
                        v-b-tooltip.focus
                        title="Editar"
                        variant="outline-primary"
                        v-b-modal.modalUpdate
                        @click="onActionClicked('edit-item', props.rowData)"
                    ><i class="bx bx-edit-alt"></i>
                    </b-button>

                    <b-button
                        tabindex="0"
                        v-b-tooltip.focus
                        title="Cambiar Estado"
                        :variant="
                        props.rowData.estado_user == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                        @click="
                        props.rowData.estado_user == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                          :class="
                          props.rowData.estado_user == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_user == true">
                    <span class="badge bg-success ms-1"
                    ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                    ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                    ref="pagination"
                    :css="css.pagination"
                    @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.rounded-corners {
  border-radius: 30px;
}
</style>